import { IHistoryProvider, HistoryProviderOptions, HistoryMetaData, GiveFeedbackParams } from "./IProvider";

export class NoneProvider implements IHistoryProvider {
    getProviderName = () => HistoryProviderOptions.None;
    resetContinuationToken(): void {
        return;
    }
    async getNextItems(count: number): Promise<HistoryMetaData[]> {
        return [];
    }

    async getItem(id: string): Promise<null> {
        return null;
    }
    async deleteItem(id: string): Promise<void> {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async giveFeedback(_params: GiveFeedbackParams): Promise<void> {
        return;
    }
}
